<template>
  <div class="ad-profit-page">
    <van-nav-bar
      title="广告收益"
      class="nav-bar"
      right-text="收益明细"
      left-arrow
      @click-left="onClickNavLeft"
      @click-right="goPageProfitList"
    />
    <div class="ad-page-main">
      <div class="page-header">
        <div class="ad-profit__bg" />
        <div class="ad-profit__card">
          <div class="ad-profit__count">
            <div class="ad-profit__count-relative">
              4288.00
              <div class="ad-profit-mark">广告币</div>
            </div>
            <span>个</span>
          </div>
          <div class="ad-profit__text">
            <div>
              累计收益
              <span>3278.00</span>个
            </div>
            <div class="m-l-10">
              已兑金额
              <span>￥3278.00</span>个
            </div>
          </div>
          <div class="exchange-btn">兑换优惠券</div>
        </div>
      </div>

      <div class="ad-profit__label">当前播放</div>

      <van-swipe
        class="ad-profit__swipe"
        :autoplay="3000"
        :show-indicators="false"
        @change="onChange"
      >
        <template v-for="(item) in 4">
          <van-swipe-item :key="item">
            <v-ad />
          </van-swipe-item>
        </template>

        <div slot="indicator" class="swipe__custom-indicator-box">
          <template v-for="(item) in 4">
            <div
              :key="item"
              class="swipe__custom-indicator"
              :class="{'swipe__indicator--active': item - 1 === current}"
            />
          </template>
        </div>
      </van-swipe>

      <div class="coupon-list-box">
        <div class="coupon-list-header">
          <div class="coupon-list-header__title">优惠券</div>
          <div class="coupon-list-header__right" @click="goPageCouponInfo">
            使用说明
            <van-icon class="icon" name="question-o" />
          </div>
        </div>
        <van-tabs v-model="tabsActive" class="ad-profit-page__tabs">
          <van-tab :name="1" title="待使用">
            <template v-for="(item) in 10">
              <v-coupon :key="item" />
            </template>
          </van-tab>
          <van-tab :name="2" title="已使用">内容 2</van-tab>
          <van-tab :name="3" title="已过期">内容 3</van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { closeWebView, goPageProfitList, goPageCouponInfo } from '@/utils/ad'
import VAd from './ad'
import VCoupon from './coupon'

export default {
  components: { VAd, VCoupon },
  data() {
    return {
      current: 0, // 轮播
      tabsActive: 1
    }
  },
  computed: {},
  watch: {},
  async created() {},
  methods: {
    onClickNavLeft() {
      closeWebView()
    },
    onChange(index) {
      this.current = index
    },

    // 去收益明细页面
    goPageProfitList() {
      // this.$router.push({ path: 'ad-profit-list' })
      goPageProfitList()
    },
    // 去优惠券说明页面
    goPageCouponInfo() {
      // this.$router.push({ path: 'ad-coupon-info' })
      goPageCouponInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.m-l-10 {
  margin-left: 10px;
}

.ad-profit-page {
  height: 100vh;
  display: flex;
  flex-flow: column;
  background-color: #f7f7f7;
}

.ad-page-main {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-bar {
  background: #41424e;

  /deep/ .van-nav-bar__title,
  /deep/ .van-icon-arrow-left,
  .van-nav-bar__text {
    color: #ffffff;
    &:active {
      background-color: #41424e;
    }
  }

  &::after {
    content: none;
  }
}

.page-header {
  position: relative;
}

.ad-profit__bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  overflow: hidden;
  // background: #41424e;
  // border-radius: 0 0 50% 50%;

  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 800px;
    height: 800px;
    transform: translateX(-50%);
    background: #41424e;
    border-radius: 50%;
  }
}

.ad-profit__card {
  position: relative;
  margin: 0 auto;
  width: 363px;
  height: 200px;
  background-image: url(~@/icons/ad/ad-card-bg.png);
  background-repeat: no-repeat;
  background-size: contain;
  // text-align: center;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  z-index: 11;

  .ad-profit__count {
    height: 37px;
    font-size: 32px;
    font-weight: bold;
    color: rgba(55, 61, 82, 1);
    line-height: 37px;
    display: flex;
    align-items: flex-end;

    .ad-profit__count-relative {
      position: relative;
    }

    span {
      margin-left: 5px;
      margin-bottom: 7px;
      height: 17px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(65, 66, 78, 1);
      line-height: 17px;
    }

    .ad-profit-mark {
      position: absolute;
      top: -11px;
      right: -45px;
      width: 43px;
      height: 23px;
      display: inline-block;
      background-image: url(~@/icons/ad/ad-profit-mark.png);
      background-repeat: no-repeat;
      background-size: contain;

      font-size: 10px;
      font-weight: 600;
      color: #ffffff;
      line-height: 18px;
      text-align: center;
    }
  }

  .ad-profit__text {
    margin-top: 15px;
    display: flex;
    height: 18px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(65, 66, 78, 1);
    line-height: 18px;

    span {
      color: #41424e;
      font-weight: bold;
    }
  }

  .exchange-btn {
    margin-top: 15px;
    width: 180px;
    height: 32px;
    background: rgba(65, 66, 78, 1);
    border-radius: 16px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(245, 232, 192, 1);
    // line-height: 20px;
    line-height: 32px;
    text-align: center;
  }
}

.ad-profit__label {
  padding: 0 15px;
  margin: 15px 0;
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 20px;
}

.ad-profit__swipe {
  padding-bottom: 12px;

  .swipe__custom-indicator-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;

    .swipe__custom-indicator {
      display: inline-block;
      margin: 0 2px;
      width: 10px;
      height: 2px;
      background: rgba(0, 0, 0, 0.1);
      border-radius: 2px;
    }

    .swipe__indicator--active {
      width: 20px;
      background: rgba(65, 66, 78, 1);
    }
  }
}

.coupon-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .coupon-list-header__title {
    height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 20px;
  }

  .coupon-list-header__right {
    display: flex;
    align-items: center;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 17px;

    .icon {
      margin-left: 3px;
      display: inline-block;
      font-size: 14px;
    }
  }
}

.ad-profit-page__tabs {
  /deep/ .van-tabs__line {
    width: 20px !important;
    height: 2px !important;
    background: rgba(65, 66, 78, 1) !important;
    border-radius: 10px !important;
  }

  /deep/ .van-tabs__wrap::after {
    border: none;
  }
}

.coupon-list-box {
  margin-top: 15px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.03);
}
</style>
